export const VERIFICATION_SELECTION_LOADING = 'VERIFICATION_SELECTION_LOADING';
export const VERIFICATION_SELECTION_FETCH_ERROR =
  'VERIFICATION_SELECTION_FETCH_ERROR';
export const VERIFICATION_SELECTION_GET_DATA =
  'VERIFICATION_SELECTION_GET_DATA';
export const VERIFICATION_SELECTION_CLEAR_PROCESS_RESULT =
  'VERIFICATION_SELECTION_CLEAR_PROCESS_RESULT';
export const VERIFICATION_SELECTION_SET_RESULT =
  'VERIFICATION_SELECTION_SET_RESULT';



// WEBPACK FOOTER //
// ./src/pages/verificationselection/state/selection/types.js